// extracted by mini-css-extract-plugin
export var badge = "_i3-2";
export var detailsPanel = "_i3-0";
export var resultRow = "_i3-1";